var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mural-card",on:{"click":_vm.onClick}},[_c('v-img',{staticClass:"mural-thumbnail",attrs:{"src":_vm.thumbnailUrl}}),_c('div',{staticClass:"mural-info"},[_c('div',{staticClass:"mural-title"},[_vm._v(_vm._s(_vm.mural.title))]),_c('div',{staticClass:"mural-details"},[_vm._v("Modified "+_vm._s(_vm.modified))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }